export const Translations = {
  'en': {
    'ordersLabel': 'Orders',
    'ordersMessage': 'Your last order was processed on',
    'overrideLabel': 'Order Now',
    'overrideMessage': 'Your next order will be processed on',
    'adrShippingMessage': 'Whether or not your selected processing date falls on a ' +
      'weekend or a weekday, your ADR will be processed on that date and shipped on ' +
      'the closest business day. However, to ensure that your changes take effect, we ' +
      'recommend making any changes at least 4 business days before your ADR is scheduled ' +
      'to be processed.'
  },
  'es': {
    'ordersLabel': 'Pedidos',
    'ordersMessage': 'Su último pedido fue procesado en',
    'overrideLabel': 'Ordenar ahora',
    'overrideMessage': 'Su próximo pedido será procesado en',
    'adrShippingMessage': 'Las fechas de procesamiento que caen en día Sábado serán enviadas ' +
      'el día Viernes, las fechas que caen en día Domingo serán enviadas el día Lunes.'
  },
  'zh': {
    'ordersLabel': '订单',
    'ordersMessage': '您的上一个订单已处理完毕',
    'overrideLabel': '现在下单',
    'overrideMessage': '您的下一个订单将被处理',
    'adrShippingMessage': '无论您选择的处理日期是周末还是工作日，您的ADR将在该日期处理并在最近的工作日发货。' +
      '但是，为确保您的更改生效，我们建议您在计划处理ADR之前至少4个工作日进行任何更改。'
  }
};
